/** @jsx jsx */
import { Global, css, jsx } from '@emotion/react';

import * as React from 'react';

import Modal from 'bundles/ui/components/Modal';

const styles = {
  global: css`
    .rc-DiscussionsModal.large {
      padding: var(--cds-spacing-300);
      border-radius: 2px;

      .c-modal-title {
        margin-bottom: var(--cds-spacing-200);
      }

      .c-modal-subtitle {
        margin-bottom: var(--cds-spacing-200);
      }

      .modal-text.success {
        text-align: center;
        margin: var(--cds-spacing-300) 0;
      }

      .button-container button:first-child {
        margin-right: var(--cds-spacing-200);
      }
    }
  `,
};

type Props = {
  handleClose?: () => void;
  modalName: string;
  allowClose?: boolean;
  trackingName?: string;
  className?: string;
  children: React.ReactNode;
};

const DiscussionsModal = ({ allowClose, handleClose, modalName, trackingName, className, children }: Props) => {
  const onRequestClose = () => {
    handleClose?.();
  };

  return (
    <React.Fragment>
      <Global styles={styles.global} />
      <Modal
        allowClose={allowClose}
        onRequestClose={onRequestClose}
        modalName={modalName}
        size="large"
        trackingName={trackingName}
        className={`rc-DiscussionsModal ${className}`}
      >
        {children}
      </Modal>
    </React.Fragment>
  );
};

export default DiscussionsModal;
